<h1 id="title" class="title">Đăng ký tài khoản</h1>

<nb-alert
  *ngIf="showMessages.error && errors?.length && !submitted"
  outline="danger"
  role="alert"
>
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert
  *ngIf="showMessages.success && messages?.length && !submitted"
  outline="success"
  role="alert"
>
  <p class="alert-title"><b>Hooray!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">
      {{ message }}
    </li>
  </ul>
</nb-alert>

<div [formGroup]="registerForm" aria-labelledby="title">
  <div class="form-control-group">
    <label for="input-title">Tên cửa hàng:</label>
    <input
      nbInput
      autofocus
      fullWidth
      fieldSize="large"
      id="input-title"
      formControlName="title"
      [status]="title.dirty ? (title.invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="title.invalid && title.touched ? true : null"
      placeholder="Tên hiển thị"
      [(ngModel)]="shop.title"
    />
    <ngx-validation-message
      label="Tên"
      [showMinLength]="title?.hasError('minlength') && title.touched"
      [showMaxLength]="title?.hasError('maxlength') && title.touched"
      [minLength]="minLoginLength"
      [maxLength]="maxLoginLength"
      [showRequired]="title?.errors?.required && title.touched"
    >
    </ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-address">Địa chỉ:</label>
    <input
      nbInput
      autofocus
      fullWidth
      fieldSize="large"
      id="input-address"
      formControlName="address"
      [status]="address.dirty ? (address.invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="address.invalid && address.touched ? true : null"
      placeholder="Nhập địa chỉ"
      [(ngModel)]="shop.address"
    />
    <ngx-validation-message
      label="Địa chỉ"
      [showMinLength]="address?.hasError('minlength') && address.touched"
      [showMaxLength]="address?.hasError('maxlength') && address.touched"
      [minLength]="minLoginLength"
      [maxLength]="maxLoginLength"
      [showRequired]="address?.errors?.required && address.touched"
    >
    </ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-fullName">Họ tên:</label>
    <input
      nbInput
      autofocus
      fullWidth
      fieldSize="large"
      id="input-fullName"
      formControlName="fullName"
      [status]="fullName.dirty ? (fullName.invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="fullName.invalid && fullName.touched ? true : null"
      placeholder="Tên hiển thị"
      [(ngModel)]="user.displayName"
    />
    <ngx-validation-message
      label="Tên"
      [showMinLength]="fullName?.hasError('minlength') && fullName.touched"
      [showMaxLength]="fullName?.hasError('maxlength') && fullName.touched"
      [minLength]="minLoginLength"
      [maxLength]="maxLoginLength"
      [showRequired]="fullName?.errors?.required && fullName.touched"
    >
    </ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-mobile">Điện thoại:</label>
    <input
      nbInput
      fullWidth
      fieldSize="large"
      id="input-mobile"
      formControlName="mobile"
      [status]="mobile.dirty ? (mobile.invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="mobile.invalid && mobile.touched ? true : null"
      placeholder="Nhập số điện thoại"
      [(ngModel)]="shop.mobile"
    />
    <ngx-validation-message
      label="Số điện thoại"
      [showMinLength]="mobile?.hasError('minlength') && mobile.touched"
      [showMaxLength]="mobile?.hasError('maxlength') && mobile.touched"
      [minLength]="9"
      [maxLength]="50"
      [showRequired]="mobile?.errors?.required && mobile.touched"
    ></ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-email">Email:</label>
    <input
      nbInput
      fullWidth
      fieldSize="large"
      id="input-email"
      formControlName="email"
      [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : ''"
      [attr.aria-invalid]="email.invalid && email.touched ? true : null"
      placeholder="Email address"
      [(ngModel)]="user.email"
    />
    <ngx-validation-message
      label="Email"
      [showPattern]="email?.hasError('pattern') && email.touched"
      [showRequired]="email?.errors?.required && email.touched"
    ></ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-password">Mật khẩu:</label>
    <input
      nbInput
      fullWidth
      fieldSize="large"
      id="input-password"
      formControlName="password"
      type="password"
      [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : ''"
      placeholder="Password"
      [(ngModel)]="user.password"
    />
    <ngx-validation-message
      label="Password"
      [showMinLength]="password?.hasError('minlength') && password.touched"
      [showMaxLength]="password?.hasError('maxlength') && password.touched"
      [showRequired]="password?.errors?.required && password.touched"
      [minLength]="minLength"
      [maxLength]="maxLength"
    ></ngx-validation-message>
  </div>

  <div class="form-control-group">
    <label for="input-re-password">Xác nhận mật khẩu:</label>
    <input
      nbInput
      fullWidth
      fieldSize="large"
      id="input-re-password"
      formControlName="confirmPassword"
      type="password"
      [status]="
        confirmPassword.dirty
          ? confirmPassword.invalid || password.value != confirmPassword.value
            ? 'danger'
            : 'success'
          : ''
      "
      placeholder="Password"
    />
    <ngx-validation-message
      label="Confirm Password"
      [showMinLength]="
        confirmPassword?.hasError('minlength') && confirmPassword.touched
      "
      [showMaxLength]="
        confirmPassword?.hasError('maxlength') && confirmPassword.touched
      "
      [showRequired]="
        confirmPassword?.errors?.required && confirmPassword.touched
      "
      [minLength]="minLength"
      [maxLength]="maxLength"
    ></ngx-validation-message>
    <p
      class="caption status-danger"
      *ngIf="password.value != confirmPassword.value"
    >
      Xác nhận mật không trùng với mật khẩu!
    </p>
  </div>

  <div
    class="form-control-group accept-group"
    *ngIf="getConfigValue('forms.register.terms')"
  >
    <nb-checkbox
      formControlName="terms"
      [required]="getConfigValue('forms.register.terms')"
    >
      Đồng ý
      <a href="https://www.kasoft.vn/dieu-khoan-su-dung.html" target="_blank"
        ><strong>điều khoản dịch vụ</strong></a
      >
    </nb-checkbox>
  </div>

  <button
    nbButton
    fullWidth
    status="primary"
    size="large"
    [disabled]="
      submitted ||
      !registerForm.valid ||
      !terms?.value ||
      password.value != confirmPassword.value
    "
    [class.btn-pulse]="submitted"
    (click)="register()"
  >
    Đăng ký
  </button>
</div>

<section
  *ngIf="socialLinks && socialLinks.length > 0"
  class="links"
  aria-label="Social sign in"
>
  or enter with:
  <div class="socials">
    <ng-container *ngFor="let socialLink of socialLinks">
      <a
        *ngIf="socialLink.link"
        [routerLink]="socialLink.link"
        [attr.target]="socialLink.target"
        [attr.class]="socialLink.icon"
        [class.with-icon]="socialLink.icon"
      >
        <nb-icon
          *ngIf="socialLink.icon; else title"
          [icon]="socialLink.icon"
        ></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
      <a
        *ngIf="socialLink.url"
        [attr.href]="socialLink.url"
        [attr.target]="socialLink.target"
        [attr.class]="socialLink.icon"
        [class.with-icon]="socialLink.icon"
      >
        <nb-icon
          *ngIf="socialLink.icon; else title"
          [icon]="socialLink.icon"
        ></nb-icon>
        <ng-template #title>{{ socialLink.title }}</ng-template>
      </a>
    </ng-container>
  </div>
</section>

<section class="another-action" aria-label="Sign in">
  Đã có tài khoản? <a class="text-link" routerLink="../login">Đăng nhập</a>
</section>
